import React, { Component} from 'react';
import styled from 'styled-components';
import RemoveIcon from 'images/RemoveIcon';
import { Input, Button } from 'partials/formElements';

import css from 'css';

export class CourseDropdown extends Component {

    constructor(props) {
        super(props)
    
        this.state = {
             value: '',
        }
    }
    
    handleClick = (e) => {
        //add course item to list
        e.preventDefault(); 
        let val = document.getElementById('course-input').value;
        this.setState({value: ''},() => this.props.addCourse(val))
    }

    handleOnChange = () => {
        //populate input field and ready for adding course
        let val = document.getElementById('course-input').value;
        this.setState({value: val})
    }

    render() {
        const { courses } = this.props;
        const { value } = this.state;

        return (
            <StyledForm>
                <StyledLabel for="courses">
                    <InputWrapper>
                        <Input 
                            type="text" 
                            name="courses" 
                            list="courses" 
                            id="course-input" 
                            className="input-wrapper"
                            value={value} 
                            onChange={() => this.handleOnChange()} 
                        />
                        <Button blue onClick={(e) => this.handleClick(e)}>Legg til<RemoveIcon color="#fff" /></Button>
                    </InputWrapper>
                    <datalist id="courses">
                        <select name="courses" id="course-select">
                            { courses.map((course,idx) =>
                                <option value={course.id} key={idx}>{course.name}</option>
                            )}
                        </select>
                    </datalist>
                </StyledLabel>
            </StyledForm>
        )
    }
}

export default CourseDropdown;


const StyledForm = styled.form`
    margin-bottom: 40px;

    input {
        border-radius: 0;
        -webkit-appearance: none;
        appearance: none;
        padding: 16px;
        width: calc(100% - 115px);
        border: none; 
        outline: none; 
    }

    @media(min-width: 768px) {
        width: 100%;
    }
`

const StyledLabel = styled.label`
    
`

const InputWrapper = styled.div`
    display: inline-flex;
    padding-top:20px;
    position: relative;
    width: 100%;
    
    .input-wrapper{
        width: calc(100% - 112px); 
        input{
            width: 100%; 
        }
    }

    input {
        height:43px;
        margin-top: 1px;
        border:none;
        border-bottom: 2px solid ${css.colors.blue};
        background: #F4F4F4;
        width: 245px;
    }

    button {
        padding: 0 15px;
        height: 44px;
        font-size: 16px;

        svg {
            transform: rotate(45deg);
            margin-left:15px;
        }
        &:hover {
            svg g {
                stroke: ${css.colors.main};
            }
        }
    }
`


// WEBPACK FOOTER //
// ./src/partials/modules/TimePlanNew/courseSelect/CourseDropdown.js